import { render, staticRenderFns } from "./ContractorCardNew.vue?vue&type=template&id=418cfa06&scoped=true"
import script from "./ContractorCardNew.vue?vue&type=script&lang=ts"
export * from "./ContractorCardNew.vue?vue&type=script&lang=ts"
import style0 from "./ContractorCardNew.vue?vue&type=style&index=0&id=418cfa06&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418cfa06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('418cfa06')) {
      api.createRecord('418cfa06', component.options)
    } else {
      api.reload('418cfa06', component.options)
    }
    module.hot.accept("./ContractorCardNew.vue?vue&type=template&id=418cfa06&scoped=true", function () {
      api.rerender('418cfa06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyContractors/ContractorCardNew.vue"
export default component.exports